import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="header"
export default class extends Controller {
  static values = { url: String }

  clickEditCompanyUser() {
    window.open(this.urlValue, null, 'width=600, height=400, menubar=no, toolbar=no, scrollbars=no');
  }
}